<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto">
      <div class="flex flex-col items-center justify-between space-y-10 lg:block">
        <div class="text-center text-2xl font-bold text-additional-50 lg:text-3xl">{{ title }}</div>
        <div class="flex w-full items-center justify-center space-x-6">
          <VcButton
            v-for="(item, index) in buttons"
            :key="index"
            v-bind="getLinkAttr(item.link)"
            class="max-w-1/2 rounded-lg bg-[color:var(--color-primary-500)] px-6 py-2 text-[18px] font-bold text-[color:var(--color-secondary-hover)] hover:text-white lg:w-auto"
          >
            {{ item.label }}
          </VcButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getLinkAttr } from "@/core/utilities/common";

type ButtonType = {
  label: string;
  link: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  title?: string;
  buttons?: Array<ButtonType>;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)",
    "py-10 lg:py-24",
  ];
});
</script>
